export function feeEstimator(inputId = 'fee-estimator-input', resultId = 'fee-estimator-result') {
  const input = document.getElementById(inputId);
  const result = document.getElementById(resultId);
  if (!input || !result || input.value.trim() === '') return;

  // Strip commas before parsing
  const rawInput = input.value.replace(/,/g, '');
  const pppKg = parseFloat(rawInput);

  if (isNaN(pppKg) || pppKg < 0) {
    result.innerHTML = `<span style="color:red;">Please enter a valid number of kilograms.</span>`;
    return;
  }

  const flatFee = 250;
  const variableRate = 0.0289;

  let variableFee = 0;
  let totalFee = 0;
  let message = '';

  if (pppKg < 1000) {
    
    totalFee = 0;
    message = `<strong>2025 EPR Oversight Fee Estimate (not including taxes):</strong><br>
      <span class="pppResult">$0.00</span><br>
      <small>No fee for less than 1,000 kg.</small>`;
  } else if (pppKg < 25000) {
    
    totalFee = flatFee;
    message = `2025 EPR Oversight Fee Estimate (not including taxes):</strong><br>
      <span class="pppResult">$${totalFee.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span><br>
      <small>Flat Fee: $${flatFee.toLocaleString('en-US', { minimumFractionDigits: 2 })}</small>`;
  } else {
   
    variableFee = pppKg * variableRate;
    totalFee = flatFee + variableFee;
    message = `2025 EPR Oversight Fee Estimate (not including taxes):</strong><br>
      <span class="pppResult">$${totalFee.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span><br>
      <small>($${flatFee.toLocaleString('en-US', { minimumFractionDigits: 2 })} Flat Fee, $${variableFee.toLocaleString('en-US', { minimumFractionDigits: 2 })} Variable Rate #kg * $0.0289)</small>`;
  }

  result.innerHTML = message;
}

export function initFeeEstimator({
  inputId = 'fee-estimator-input',
  buttonId = 'fee-estimator-button',
  resultId = 'fee-estimator-result'
} = {}) {
  const input = document.getElementById(inputId);
  const button = document.getElementById(buttonId);

  if (!input || !button) return;

  // Enforce numeric input with one decimal
  input.addEventListener('beforeinput', function (e) {
    const char = e.data;
    const isAllowed = /^[0-9.]$/.test(char) || e.inputType === 'deleteContentBackward';

    if (char === '.' && this.value.includes('.')) {
      e.preventDefault();
      return;
    }

    if (!isAllowed) {
      e.preventDefault();
    }
  });

  // Live comma formatting as user types
  input.addEventListener('input', function () {
    const rawValue = input.value.replace(/[^\d.]/g, '');
    const parts = rawValue.split('.');
    let integerPart = parts[0];
    let decimalPart = parts.length > 1 ? parts[1] : '';

    if (integerPart) {
      integerPart = parseInt(integerPart, 10).toLocaleString('en-US');
    }

    input.value = decimalPart ? `${integerPart}.${decimalPart}` : integerPart;

    // Optional: Keep cursor at end
    setTimeout(() => {
      input.selectionStart = input.selectionEnd = input.value.length;
    }, 0);
  });

  // Run fee calculation on button click
  button.addEventListener('click', () => {
    feeEstimator(inputId, resultId);
  });

  // Run fee calculation on Enter key
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      feeEstimator(inputId, resultId);
    }
  });
}



 
